const StockStatuses = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  RESERVED: 'RESERVED',
  TBO_PRERESERVED: 'TBO_PRERESERVED',
  ORDERED_TBC: 'ORDERED_TBC',
  PRERESERVED_TBC: 'PRERESERVED_TBC',
  ORDERED: 'ORDERED',
  PRERESERVED: 'PRERESERVED',
  DAMAGED: 'DAMAGED',
  SOLD: 'SOLD',
  INVOICE: 'INVOICE',
  ON_ORDER: 'ON_ORDER',
  INVOICED: 'INVOICED',
  TRANSIT: 'TRANSIT'
})

export default StockStatuses
